"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = __importDefault(require("md5"));
var PLACEHOLDERS = {
    user: 'https://cdn.auth0.com/website/cosmos/avatar-user-default.svg',
    resource: 'https://cdn.auth0.com/website/cosmos/avatar-resource-default.svg'
};
var initialsAvatar = function (initials) {
    return initials
        ? encodeURIComponent("https://cdn.auth0.com/avatars/" + initials.toLowerCase() + ".png")
        : '404';
};
var urlTemplate = function (hash, initials, size) {
    return "https://s.gravatar.com/avatar/" + hash + "?s=" + size + "&r=pg&d=" + initialsAvatar(initials);
};
function avatarUrl(email, initials, type, size) {
    if (type === void 0) { type = 'user'; }
    if (size === void 0) { size = 480; }
    if (typeof email !== 'string' && typeof initials !== 'string') {
        return PLACEHOLDERS[type];
    }
    var hash = email ? md5_1.default(email.toLowerCase()) : '';
    return urlTemplate(hash, initials, size);
}
exports.default = avatarUrl;
//# sourceMappingURL=avatar-url.js.map